import { getVariboxById, listVariboxes, mapApiVariboxToView, type VariboxViewRecord } from '@/services/variboxApi';

function normalizeBarcode(barcode: string) {
  return barcode.trim().replace(/\s+/g, '').toUpperCase();
}

function matchesBarcode(value: string, normalizedBarcode: string) {
  return normalizeBarcode(value) === normalizedBarcode;
}

export async function findVariboxByBarcode(barcode: string): Promise<VariboxViewRecord | undefined> {
  const scannedValue = barcode.trim();
  let recordId: string | null = null;
  const identifiers = [scannedValue];

  try {
    const payload = JSON.parse(scannedValue) as {
      type?: unknown;
      version?: unknown;
      id?: unknown;
      barcode?: unknown;
      serial_number?: unknown;
      radex_identifier?: unknown;
    };
    if (payload.type === 'assetflow.varibox' && payload.version === 1) {
      recordId = typeof payload.id === 'string' ? payload.id : null;
      identifiers.splice(0, identifiers.length);
      for (const identifier of [payload.barcode, payload.serial_number, payload.radex_identifier]) {
        if (typeof identifier === 'string' && identifier.trim()) {
          identifiers.push(identifier);
        }
      }
    }
  } catch {
    // A plain barcode/serial number is also a valid scan payload.
  }

  if (recordId) {
    try {
      return mapApiVariboxToView(await getVariboxById(recordId));
    } catch {
      // If the encoded record ID is stale, fall back to its unique barcode values.
    }
  }

  if (!identifiers.length) {
    return undefined;
  }

  for (const identifier of identifiers) {
    const normalizedIdentifier = normalizeBarcode(identifier);
    if (!normalizedIdentifier) {
      continue;
    }

    const response = await listVariboxes({ search: identifier, limit: 50 });
    const exactMatch = response.items.find((item) => {
      return matchesBarcode(item.barcode, normalizedIdentifier)
        || matchesBarcode(item.serial_number, normalizedIdentifier)
        || matchesBarcode(item.radex_identifier, normalizedIdentifier);
    });

    if (exactMatch) {
      return mapApiVariboxToView(exactMatch);
    }
  }

  return undefined;
}
